import { initializeCalendarField } from './includes/calendar.js';
import { elements } from './includes/elements.js';
import { fieldUse, commonFields } from './includes/fieldUse.js';
import { hiddenClass } from '../config.js';
import { attachValidationListeners } from './includes/validateForm.js';
import { attachSubmitHandler } from './includes/submitForm.js';
import Choices from 'choices.js';

export const recaptchaId = 'recaptcha-inline-badge';
export const recaptchaDataAttr = 'data-client-id';

export const initializeContactForm = () => {
    const {
        contactForm,
        submitButton,
        allDropdowns,
        enquiryType,
        formIdInput,
        expectedStartDate,
        privacyPolicyText,
    } = elements;

    if (!contactForm || !submitButton || !privacyPolicyText) return;

    const toggleFieldVisibility = (selectedType) => {
        // Hide all fields and sections using a unique class
        document.querySelectorAll('.js-contact-field, .js-contact-section').forEach((element) => {
            element.classList.add(hiddenClass);
        });

        // Show fields and sections for the selected enquiry type
        if (fieldUse[selectedType]) {
            // show field wrapper
            const formInputs = document.querySelector('.js-form-inputs');
            if (formInputs) formInputs.classList.remove(hiddenClass);

            // Show common fields
            Object.values(commonFields).forEach((className) => {
                const field = document.querySelector(`.${className}`);
                if (field) field.closest('.form-control').classList.remove(hiddenClass);
            });

            // Show extra fields
            const extraFields = fieldUse[selectedType]?.extraFields || {};
            Object.values(extraFields).forEach((className) => {
                const field = document.querySelector(`.${className}`);
                if (field) field.closest('.form-control').classList.remove(hiddenClass);
            });

            // Show extra sections
            const extraSections = fieldUse[selectedType]?.extraSections || [];
            extraSections.forEach((sectionClass) => {
                const section = document.querySelector(`.${sectionClass}`);
                if (section) section.classList.remove(hiddenClass);
            });
        }
    };

    const toggleSubmitAndPrivacyPolicy = () => {
        if (enquiryType.value === "") {
            submitButton.classList.add(hiddenClass);
            privacyPolicyText.classList.add(hiddenClass);
        } else {
            submitButton.classList.remove(hiddenClass);
            privacyPolicyText.classList.remove(hiddenClass);
        }
    };

    // Initialize visibility based on the default selected enquiry type
    toggleFieldVisibility(enquiryType.value);
    toggleSubmitAndPrivacyPolicy();

    // Attach validation listeners for the default enquiry type
    attachValidationListeners(contactForm);

    // Add event listener to toggle visibility and update validation on enquiry type change
    enquiryType.addEventListener('change', (event) => {
        const selectedType = event.target.value;
        toggleFieldVisibility(selectedType);
        toggleSubmitAndPrivacyPolicy();

        // Update form_id dynamically
        if (fieldUse[selectedType]) {
            formIdInput.value = fieldUse[selectedType].formId;
        }
    });

    // Initialise all dropdowns
    if (allDropdowns?.length) {
        allDropdowns.forEach(dropdown => {
            new Choices(dropdown, {
                shouldSort: false,
                searchEnabled: false,
            });
        });
    }

    // Initialize calendar field with correct display and submission formats
    initializeCalendarField(expectedStartDate);

    // Attach the submit handler
    attachSubmitHandler();
};

window.onRecaptchaLoadCallback = () => {
    if (typeof grecaptcha === 'undefined') return;

    const recaptchaInput = document.querySelector(`#${recaptchaId}`);
    if (!recaptchaInput) return;

    const clientId = grecaptcha.render(recaptchaId, {
        'sitekey': '6LfhDxkrAAAAAKqn0osmZ9dgBHjnBnrIJ-pejx4l',
        'badge': 'inline',
        'size': 'invisible'
    });
    recaptchaInput.setAttribute(recaptchaDataAttr, clientId);
}
